/* lua.js generated code 0.3.0 */

RemoteDebug = table([1, "logStr", ""])
var recursion_log = null
recursion_log = function (arg) {
    var __VA_ARG = $slice(arguments, 1)
    var str = arg || "nil"
    if ($len(table([2, __VA_ARG])) === 0) {
        return tostring(str) + "\n"
    }
    return tostring(str) + " " + recursion_log(...__VA_ARG)
}
RemoteDebug.log = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.logStr = self.logStr + "[RemoteDebug] " + recursion_log(...__VA_ARG)
}
RemoteDebug.logWithLuaPrint = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    cc.log("[RemoteDebug] ", ...__VA_ARG)
    RemoteDebug.uploadLog(...__VA_ARG)
}
RemoteDebug.uploadLog = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var str = null
    if ($len(table([2, __VA_ARG])) === 0) {
        str = self.logStr
        self.logStr = ""
    } else {
        str = "[RemoteDebug] " + recursion_log(...__VA_ARG)
    }
    if ($len(table([2, __VA_ARG])) === 0 && str === "") {
        return 
    }
    var request = he.HttpRequest.createPost("http://127.0.0.1/log.php")
    request.setConnectionTimeoutMs(2 * 1000)
    request.setTimeoutMs(30 * 1000)
    request.addHeader("Content-Type:application/octet-stream")
    var md5_path = he.HeResPathUtils.getResCachePath()
    var f = io.open(md5_path + "/static_config.md5", "r")
    if (f) {
        var md5 = f.read("*all")
        str = "client md5:" + md5 + "\n" + str
    }
    request.setPostData(str, string.len(str))
    function onRegisterFinished(response) { }
    he.HttpClient.getInstance().sendRequest(onRegisterFinished, request)
}
